import React from 'react';
import Icon from '../../../components/AppIcon';

const PlatformMetricsCard = ({ title, value, subtitle, icon, iconColor, trend, trendType }) => {
  return (
    <div className="bg-card rounded-xl shadow-warm p-4 md:p-6 transition-smooth hover:shadow-warm-md">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-muted-foreground text-sm md:text-base font-caption mb-1">{title}</p>
          <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground data-text">
            {value}
          </p>
          {subtitle && (
            <p className="text-xs md:text-sm text-muted-foreground mt-1">{subtitle}</p>
          )}
        </div>
        <div 
          className="w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: `${iconColor}15` }}
        >
          <Icon name={icon} size={24} color={iconColor} />
        </div>
      </div>
      
      {trend && (
        <div className="flex items-center gap-2">
          <div className={`flex items-center gap-1 px-2 py-1 rounded-md ${
            trendType === 'positive' ? 'bg-success/10' : 
            trendType === 'negative' ? 'bg-error/10' : 'bg-muted'
          }`}>
            <Icon 
              name={trendType === 'positive' ? 'TrendingUp' : trendType === 'negative' ? 'TrendingDown' : 'Minus'} 
              size={14} 
              color={
                trendType === 'positive' ? 'var(--color-success)' : 
                trendType === 'negative' ? 'var(--color-error)' : 'var(--color-muted-foreground)'
              }
            />
            <span className={`text-xs md:text-sm font-semibold data-text ${
              trendType === 'positive' ? 'text-success' : 
              trendType === 'negative' ? 'text-error' : 'text-muted-foreground'
            }`}>
              {trend}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlatformMetricsCard;